// src/components/e-commerce/product-details/tabs/reviews/media-preview-item.tsx
"use client"

import { X } from "lucide-react"
import type { MediaAttachment } from "@/services/media-upload-service"

interface MediaPreviewItemProps {
  attachment: MediaAttachment
  onRemove: () => void
  disabled: boolean
}

export function MediaPreviewItem({
  attachment,
  onRemove,
  disabled,
}: MediaPreviewItemProps) {
  return (
    <div className='relative h-20 w-20 overflow-hidden rounded-lg border border-gray-200'>
      {attachment.type === "image" ? (
        <img
          alt='Review image'
          className='h-full w-full object-cover'
          src={attachment.url}
        />
      ) : (
        <div className='flex h-full w-full items-center justify-center bg-gray-100 text-gray-600 text-xs'>
          Video
        </div>
      )}
      <button
        aria-label='Remove media'
        className='absolute top-1 right-1 flex h-5 w-5 items-center justify-center rounded-full bg-black/60 transition-colors hover:bg-black/80 disabled:bg-gray-400/60'
        disabled={disabled}
        onClick={onRemove}
        type='button'
      >
        <X className='h-3 w-3 text-white' />
      </button>
    </div>
  )
}
